import React from 'react';

// COMPONENTS
import Icon from '../Icon';

// ENUMS
import { Icons } from '../../enums/icons';

// INTERFACES
import { IStep } from '../../interfaces/Steps.interface';

// STYLES
import { SingleStepNumberSquare } from './styles';

interface IStepMobileClosed {
  step: IStep;
}

const StepMobileClosed = ({ step }: IStepMobileClosed) => {
  const { active, complete } = step;

  return (
    <SingleStepNumberSquare active={active} complete={complete} closed>
      {complete ? <Icon type={Icons.CHECK_MARK} /> : step.step}
    </SingleStepNumberSquare>
  );
};

export default StepMobileClosed;
